import { coreApi } from '@cp/shared/api/core';
import { CallViewModel, GetCallsRequest } from '@common/model/dialog/getCalls.request';
import { StartCallRequest } from '@common/model/dialog/startCall.request';

export enum CallTags {
  ActiveCalls = 'ActiveCalls',
  Call = 'Call',
}

export const coreCallApi = coreApi.enhanceEndpoints({ addTagTypes: Object.values(CallTags) }).injectEndpoints({
  endpoints: (builder) => ({
    getCalls: builder.query<CallViewModel[], GetCallsRequest>({
      query: (params) => ({
        url: '/dialogs/calls',
        params,
      }),
      providesTags: (result) =>
        result
          ? [...result.map(({ id }) => ({ type: CallTags.Call, id }) as const), { type: CallTags.ActiveCalls } as const]
          : [{ type: CallTags.ActiveCalls } as const],
    }),
    getCall: builder.query<CallViewModel, { id: string }>({
      query: ({ id }) => ({
        url: `/dialogs/calls/${id}`,
      }),
      providesTags: (result, error, { id }) => [{ type: CallTags.Call, id }],
    }),
    startCall: builder.mutation<void, StartCallRequest>({
      query: (body) => ({
        url: '/admin/dialogs/calls',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: CallTags.ActiveCalls }],
    }),
  }),
});
